export function setScore(score) {
    return {
        type: 'GAMEINFO_SET_SCORE',
        payload: score
    };
}

export function setLives(lives) {
    return {
        type: 'GAMEINFO_SET_LIVES',
        payload: lives
    };
}

export function setHealth(health) {
    return {
        type: 'GAMEINFO_SET_HEALTH',
        payload: health
    };
}

export function setTime(time) {
    return {
        type: 'GAMEINFO_SET_TIME',
        payload: time
    };
}

export function setViewDir(viewDir) {
    return {
        type: 'GAMEINFO_SET_VIEW_DIR',
        payload: viewDir
    };
}

export function setPaused(isPaused) {
    return {
        type: 'GAMEINFO_SET_PAUSED',
        payload: isPaused
    };
}

export function setMuted(isMuted) {
    return {
        type: 'GAMEINFO_SET_MUTED',
        payload: isMuted
    };
}

export function setFullscreen(isFullscreen) {
    return {
        type: 'GAMEINFO_SET_FULLSCREEN',
        payload: isFullscreen
    };
}

export function setAllGameInfo(info) {
    return {
        type: 'GAMEINFO_SET_ALL_GAME_INFO',
        payload: info
    };
}

export function setAllPlayerInfo(info) {
    return {
        type: 'GAMEINFO_SET_ALL_PLAYER_INFO',
        payload: info
    };
}

export function setAllLevelGoalInfo(info) {
    return {
        type: 'GAMEINFO_SET_ALL_GOALS',
        payload: info
    };
}
